import { render } from "./WCFormGroup.vue?vue&type=template&id=9877bad6"
import script from "./WCFormGroup.vue?vue&type=script&lang=js"
export * from "./WCFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__